import { useMemo } from "react";
import { object, string, date, bool, ref } from "yup";
import { testBirthdate, testTitre, testPassword, testTelephone } from "src/commun/utils/ValidationsUtils";
import { Title } from "src/commun/hooks/useTitreOptions";

export type InfoPerso = {
  title: Title;
  firstName: string;
  lastName: string;
  birthdate: string;
  telephonePro: string;
  password: string;
  confirmationPassword: string;
  acceptCGU: boolean;
};

const useValidationSchemaInfoPerso = () => {
  return useMemo(() => {
    const requiredMessage = "form.error.notEmpty";
    const invalidMessage = "form.error.invalid";
    const passwordsDifferents = "form.error.passwordDoesntMatch";
    const CGUNotAccepted = "form.error.cguNotAccepted";

    // Schema représentant l'ensemble des champs du formulaire
    // inclu la validation de ces champs si nécessaire
    const validationSchema = object<InfoPerso>().shape({
      title: string().required(requiredMessage).test("test-title", invalidMessage, value => testTitre(value)),
      lastName: string().required(requiredMessage),
      firstName: string().required(requiredMessage),
      birthdate: date().required(requiredMessage).typeError("").test("test-birthdate", invalidMessage, value => testBirthdate(value)),
      telephonePro: string().nullable().test("telephone-format-fr-ch", invalidMessage, (value) => testTelephone(value)),
      password: string().required(requiredMessage)
        .test("test-password", invalidMessage, value => testPassword(value)),
      confirmationPassword: string().when("password", (password, field) =>
          password ? field.required(requiredMessage).oneOf([ref('password')], passwordsDifferents) : field),
      acceptCGU: bool().required(requiredMessage).test("test-cgu", CGUNotAccepted, value => value === true),
    });
    return validationSchema;
  }, []);
};

export default useValidationSchemaInfoPerso;
